import React from 'react';
import PropTypes from 'prop-types';

const Minus = ({ className, color }) => {
  return (
    <svg
      className={className}
      width="7"
      height="3"
      viewBox="0 0 7 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.175438 0.151999H6.84744V2.168H0.175438V0.151999Z"
        fill={color}
      />
    </svg>
  );
};
Minus.propTypes = {
  className: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

export default Minus;
